<!-- TODO this whole thing could be stored as markdown somewhere and then just rendered out -->
 <!-- Magic -->
 @if (game == gameTypes.Magic) {
    <!-- CSV -->
    @if (format == collectionFormats.Csv) {
        <div class="flex flex-col gap-2 rounded shadow-sm bg-slate-50 p-2 text-xs text-slate-600">
            <p>
                Generic CSV import supports the following columns:
            </p>
            <div class="pl-2 text-xs/6">
                <span class="bg-slate-100 p-1">count</span>, 
                <span class="bg-slate-100 p-1">foil_count</span>, 
                <span class="bg-slate-100 p-1">proxy_count</span>, 
                <span class="bg-slate-100 p-1">name</span>, 
                <span class="bg-slate-100 p-1">set_code</span>, 
                <span class="bg-slate-100 p-1">set_index</span>, 
                <span class="bg-slate-100 p-1">id</span>, 
                <span class="bg-slate-100 p-1">scryfall_id</span>
            </div>
            <p>
                Not all columns are required, however at least one of the following must be present for each row to resolve the card:
            </p>
            <div class="pl-2">
                <span class="bg-slate-100 p-1 text-xs/6">id</span> OR (<span class="bg-slate-100 p-1">set_code</span> AND <span class="bg-slate-100 p-1">set_index</span>) OR <span class="bg-slate-100 p-1">name</span> OR <span class="bg-slate-100 p-1">scryfall_id</span>
            </div>
            <p>
                It is expected that all columns present in the first row are present in all subsequent rows.
            </p>
            <p>
                Example CSV:
            </p>
            <div class="flex flex-col gap-1 p-2 bg-slate-100 slate-400 font-mono shadow-sm overflow-x-auto text-nowrap">
                <span>count,foil_count,proxy_count,proxy_count,name,set_code,set_index,id,scryfall_id</span>
                <span>0,1,0,"Crop Rotation",2XM,349,01902c2f-28ef-7185-86c1-2d2d5a28d8fd,187abedf-c2eb-453b-bea0-a10afa399e03</span>
                <span>1,1,0,"Ojer Taq, Deepest Foundation // Temple of Civilization",LCI,26,019029b8-2652-7aee-827b-8ad0ae457358,1ca79dd4-67fc-496c-96fc-489b039c4932</span>
            </div>
        </div>
    } 
    <!-- Urza Gatherer -->
    @else if (format == collectionFormats.UrzaGatherer) {
        <div class="flex flex-col gap-2 rounded shadow-sm bg-slate-50 p-2 text-xs text-slate-600">
            <p>
                Due to differences in internal data structures, the transfer to/from Urza Gatherer is not 100% lossless.
            </p>
            <ul class="list-disc pl-6 pr-6">
                <li>Urza tracks foil-etched cards separately from foil cards. Ponder does not.</li>
                <li>Urza does not allow adding individual proxy cards, instead flagging the entire stack.</li>
                <li>Urza supports 96% of the cards Ponder does, so some may be unavailable for export.</li>
                <li>Other metadata (such as date added, grading, etc.) does not transfer between.</li>
            </ul>
        </div>
    }
 }
